<template>
  <label :class="classList" :for="isFor">
    <slot></slot>
    <span v-if="required">{{' '}}*</span>
  </label>
</template>

<script>
export default {
  props: {
    isFor: String,
    small: Boolean,
    required: [Boolean, String],
  },

  computed: {
    classList() {
      return {
        'c-form__label': true,
        'c-form__label--small': this.small,
      };
    },
  },

  name: 'form-label',
};
</script>

<style lang="scss">
.c-form__label {
  font-size: 20px;
  margin: 0;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  display: block;
  color: #202020;

  span {
    color: $colour-nhs-emergency-red;
  }

  &--small {
    font-size: 14px;
  }
}
</style>
